import { createSelector } from 'reselect'

const qsSelector = state => state.qs

export default createSelector(
	[qsSelector],
	qsSelectorData => ({
		isSessionPreview: qsSelectorData.isSessionPreview === '1',
		pinCode: qsSelectorData.pincode,
	})
)
